import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const createFabricationSpecs = async (
	specs: Record<string, unknown> & { ProductId: number; AreaAssetId: number },
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductId", value: specs.ProductId },
		{ name: "AreaAssetId", value: specs.AreaAssetId },
	];
	return await apiService.callV2("[FAB].[UpsertFabricationSpecs]", parameters);
};

export const updateFabricationSpecs = async (
	productId: number,
	areaAssetId: number,
	fields: Record<string, string | number | boolean | null>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductId", value: productId },
		{ name: "AreaAssetId", value: areaAssetId },
	];

	for (const [field, value] of Object.entries(fields)) {
		parameters.push({ name: field, value: value });
	}

	return await apiService.callV2("[FAB].[UpsertFabricationSpecs]", parameters);
};

export const deleteFabricationSpecs = async (
	productId: number,
	areaAssetId: number,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductId", value: productId },
		{ name: "AreaAssetId", value: areaAssetId },
	];
	return await apiService.callV2("[FAB].[DeleteFabricationSpecs]", parameters);
};
